import React from "react";
import { useNavigate } from "react-router-dom";
import { getAssetUrl } from "../utils/assetUrl";
import "./LlwinGameChoiceModal.css";

export interface LlwinGameChoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LlwinGameChoiceModal: React.FC<LlwinGameChoiceModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSelectGame = (route: string) => {
    onClose();
    navigate(route);
  };

  return (
    <div
      className="llwin-choice-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="llwin-choice-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="llwin-choice-panel"
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          backgroundImage: `url(${getAssetUrl("/assets/bg-popup.png")})`,
        }}
      >
        <button
          type="button"
          className="llwin-choice-panel__close"
          onClick={onClose}
          aria-label="Đóng"
        >
          &times;
        </button>

        <div className="llwin-choice-panel__inner">
          <h2 id="llwin-choice-title" className="llwin-choice-panel__title">
            CHỌN LOẠI GAME
          </h2>

          <div className="llwin-choice-panel__options">
            <button
              type="button"
              className="llwin-choice-panel__btn"
              onClick={() => handleSelectGame("/casino/lobby")}
            >
              BACCARAT
            </button>

            <button
              type="button"
              className="llwin-choice-panel__btn"
              onClick={() => handleSelectGame("/NH")}
            >
              NỔ HŨ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LlwinGameChoiceModal;
